module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.filteredPeople), function(person) {
    return [(person) ? _c('person-list-item', {
      key: person.id,
      attrs: {
        "with-edit": _vm.withEdit,
        "person": person
      },
      on: {
        "selected": function($event) {
          return _vm.$emit("selected", person)
        },
        "edit": function($event) {
          return _vm.$emit("selected", person)
        }
      }
    }) : _vm._e(), _vm._v(" "), (person) ? _c('v-divider', {
      key: ("div-" + (person.id))
    }) : _vm._e()]
  }), _vm._v(" "), _c('v-layout', [(_vm.filteredPeople && _vm.filteredPeople.length === 0 && _vm.request && _vm.request.loading) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "size": "20",
      "width": "2",
      "indeterminate": "",
      "color": "amber"
    }
  }), _vm._v("\n      " + _vm._s(_vm.$t("notices.searching")) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.filteredPeople && _vm.filteredPeople.length === 0 && _vm.request && !_vm.request.loading) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("notices.noresults")) + "\n    ")]) : _vm._e()], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-601e95a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medicalaid/PersonList.vue
// module id = 1441
// module chunks = 9